{
    "dependencies": {
        "@jgoz/esbuild-plugin-html": "1.0.6",
        "@types/createjs": "0.0.32",
        "@types/node": "20.12.2",
        "@types/react": "16.14.60",
        "b64-to-blob": "1.2.19",
        "base64-js": "1.5.1",
        "brace": "0.11.1",
        "date-fns": "1.30.1",
        "date-now": "1.0.1",
        "debounce": "1.2.1",
        "eplayer-core": "git+ssh://git@bitbucket.ce.wolterskluwer.io:7999/ece/eplayer-core.git#c1537e15",
        "esbuild": "0.28.1",
        "esbuild-plugins-node-modules-polyfill": "1.8.2",
        "esbuild-sass-plugin": "3.7.0",
        "esbuild-server": "0.3.0",
        "esbuild-ts-paths": "1.1.3",
        "gl-mat4": "1.2.0",
        "gl-vec3": "1.1.3",
        "jsesc": "2.5.2",
        "mobx": "4.15.7",
        "mobx-react": "5.4.4",
        "mobx-state-tree": "3.17.3",
        "mobx-utils": "5.0.0",
        "mousetrap": "1.6.5",
        "polyp": "git+ssh://git@bitbucket.ce.wolterskluwer.io:7999/ece/polyp#22248f3",
        "prop-types": "15.8.1",
        "react": "16.14.0",
        "react-ace": "6.6.0",
        "react-color": "2.19.3",
        "react-dom": "16.14.0",
        "react-maskedinput": "4.0.1",
        "react-select": "1.3.0",
        "react-transition-group": "2.9.0",
        "sass-embedded": "1.97.3",
        "temporal-polyfill": "0.2.5",
        "tsconfig-paths": "4.2.0",
        "tslib": "2.6.2",
        "tsx": "4.7.3",
        "typescript": "5.1.6"
    },
    "description": "",
    "devDependencies": {
        "@playwright/test": "1.42.1",
        "@types/tape": "4.13.4",
        "@types/tape-async": "2.3.4",
        "maven-deploy": "1.5.0",
        "tap-dot": "2.0.0",
        "tape": "4.17.0",
        "tape-async": "2.3.0"
    },
    "engines": {
        "node": "20.x.x"
    },
    "main": "index.html",
    "name": "EmmiAuthoringTool",
    "overrides": {
        "@babel/runtime": "7.26.10",
        "braces": "3.0.3",
        "immutable": "5.1.8",
        "lodash": "4.17.21",
        "lodash-es": "4.17.23",
        "micromatch": "4.0.8",
        "minimatch": "3.1.5",
        "picomatch": "2.3.2",
        "readdirp": "5.0.0"
    },
    "private": true,
    "scripts": {
        "archive": "cd dist; jar cMf ../authoring-tool-frontend.zip *",
        "build": "tsx build.esbuild.mts",
        "clean": "rm -rf ./dist",
        "deploy-maven-release": "node ./scripts/maven-deploy-release.js",
        "deploy-maven-snapshot": "node ./scripts/maven-deploy-snapshot.js",
        "maven-deploy": "./scripts/maven-deploy.sh",
        "postbuild": "cp ./app/favicon* ./dist",
        "start": "tsx serve.esbuild.mts",
        "test": "playwright test",
        "test:build": "./node_modules/.bin/tsc --allowJs --esModuleInterop --sourceMap --outdir tests/lib app/scripts/models/{*,**/*,**/**/*}.js",
        "test:models": "node tests/models",
        "test:ui": "playwright test --ui",
        "test:unit": "tsx ./node_modules/.bin/tape app/scripts/*.test.js | tap-dot",
        "version": "bin/version.js dist/version.json"
    },
    "version": "2.40.1-2"
}